<div class="icon-container">
    <span (click)="imageModal()">
        <app-icon ic="IcImage" size="s" color="var(--color-primary-60)"></app-icon>
    </span>

    <app-icon ic="IcTrash" size="s" color="var(--color-primary-60)" (click)="deleteBtnAction()"></app-icon>
</div>
